import React from 'react';
import img000 from '../components/images/sample.png';
import img2050 from '../components/images/rflipkart.jpg';

const Events = () => {
    return (
        <>
            <div className="row m-2">
                <img className="img-fluid" src={img2050} alt="flipkart" />
            </div>

            <div className="container">
                <div className="row">
                    <div className="col-12 col-md-6">
                        <h2>Why Register for Flipkart?</h2>
                        <p>
                            <strong>Registering on Flipkart</strong> enables you to access a massive customer base,
                            increase your sales, and grow your business with ease.
                        </p>
                    </div>
                    <div className="col-12 col-md-6">
                        <img className="img-fluid" src={img000} alt="Queryimg" />
                    </div>
                </div>

                <div className="row mt-4">
                    <div className="col-12 col-md-6">
                        <h2>Essential Details Required:</h2>
                        <ul className="list-group">
                            <li className="list-group-item"><strong>Email ID:</strong> For account creation and correspondence.</li>
                            <li className="list-group-item"><strong>Contact Number:</strong> Necessary for verification and support.</li>
                            <li className="list-group-item"><strong>GST Certificate:</strong> Mandatory for compliance and to start selling.</li>
                            <li className="list-group-item"><strong>Pickup Address:</strong> Required for product collection and delivery processes.</li>
                            <li className="list-group-item"><strong>Bank Details / Cancelled Cheque:</strong> To ensure secure and prompt payment transfers.</li>
                            <li className="list-group-item"><strong>Product Category:</strong> To help list your products under the relevant categories.</li>
                        </ul>
                    </div>
                    <div className="col-12 col-md-6">
                        <img className="img-fluid" src={img000} alt="Queryimg" />
                    </div>
                </div>

                <p className="mt-4">
                    <strong>Expand your business reach</strong> with Flipkart. Contact E Seller Support for professional registration assistance.
                </p>
            </div>
        </>
    );
};

export default Events;
